import React from "react";
import { useHappyHourContext } from "@src/lib/happyHour/HappyHourContext";
import { EHappyHourLocation } from "@src/lib/happyHour/types/HappyHour.interface";
import StandardBanner from "@src/layout/DefaultLayout/DefaultHeader/TopBanner/StandardBanner";

interface IHappyHourBannerProps {
  location?: EHappyHourLocation;
  onToggleTopBanner?: (visible: boolean) => void;
}

const HappyHourBanner = (props: IHappyHourBannerProps) => {
  const { onToggleTopBanner, location } = props;

  const {
    data: happyHourData,
    setTopBannerClosed,
    topBannerClosed,
  } = useHappyHourContext();
  const happyHourMessage = location ? happyHourData?.[location] : undefined;

  if (!happyHourMessage || topBannerClosed) {
    return null;
  }

  return (
    <StandardBanner
      {...{
        onToggleTopBanner,
        handleClose: () => {
          setTopBannerClosed?.(true);
        },
        message: {
          id: "happy_hour_banner",
          text: happyHourMessage.message || "",
          link: happyHourMessage.url,
        },
      }}
    />
  );
};

export default HappyHourBanner;
